import { useState } from "react";
import { DatePicker } from "react-rainbow-components";
import { useSelector } from "react-redux/es/exports";
import styled from "styled-components";

import { TbArrowsLeftRight } from "react-icons/tb";
import { BsPlusLg } from "react-icons/bs";
import { AiOutlineMinus } from "react-icons/ai";
import Support from "../components/Supports";
import Faq from "../components/FAQ";
import { selectIranOut } from "../redux/FaqSlice";
import { Helmet } from "react-helmet";

import { Inputs } from "./TrainTicket";
import { DatePickers } from "./TrainTicket";
import { Select } from "./TrainTicket";
import { Passengers } from "./TrainTicket";

const OutsideIran = () => {
  const [date, setDate] = useState(new Date());
  const [isoneWay, setIsOneWay] = useState("single");
  const [adult, setAdult] = useState(1);
  const [child, setChild] = useState(0);
  const [newBorn, setNewBorn] = useState(0);
  const [isHidden , setIsHidden] = useState (true)

  let querstions = useSelector(selectIranOut);

  let FaqElems = querstions.map((question) => {
    return Object.entries(question)[1];
  });

  const passengers = document.getElementById("passengers");
  let allPassengers = adult + child + newBorn;

  const addAdult = () => {
    setAdult(adult + 1);
  };
  const minuseAdult = () => {
    if (adult == 1) {
      return;
    }
    setAdult(adult - 1);
  };
  const addChild = () => {
    setChild(child + 1);
  };
  const minuseChild = () => {
    if (child == 0) {
      return;
    }
    setChild(child - 1);
  };
  const addNewBorn = () => {
    setNewBorn(newBorn + 1);
  };
  const minuseNewBorn = () => {
    if (newBorn == 0) {
      return;
    }
    setNewBorn(newBorn - 1);
  };

  const passengerNum = () => {
  setIsHidden(!isHidden)
  };
  return (
    <>
      <Helmet>
        <title>بلیط پرواز های خارجی</title>
      </Helmet>

      <Inputs>
        <div className="selectContainer">
          <Select
            name="way"
            id="chooseWay"
            onChange={(event) => {
              setIsOneWay(event.target.value);
            }}
          >
            <option value="single">یک طرفه</option>
            <option value="range">رفت و برگشت</option>
          </Select>
          <Select
            name="way"
            id="chooseWay"
            onChange={(event) => {
              setIsOneWay(event.target.value);
            }}
          >
            <option value="single">اکونومی</option>
            <option value="range">فرست کلاس</option>
            <option value="range">بیزینس</option>
          </Select>
        </div>

        <input type="text" placeholder="مبدا(شهر)" className="textInput" />
        <input
          type="text"
          placeholder="مقصد (شهر)"
          className="textInput"
          style={{ paddingRight: "25px" }}
        />
        <button className="changeCities">
          <TbArrowsLeftRight />
        </button>
        <DatePickers
          value={date}
          name="انتخاب تاریخ سفر"
          placeholder="انتخاب تاریخ سفر"
          onChange={(value) => setDate(value)}
          selectionType={isoneWay}
          label="انتخاب تاریخ سفر"
        />

        <section className="inputRule" onClick={passengerNum}>
          {`${allPassengers} مسافر`}
          <label>مسافران</label>
        </section>

        <button className="searchButton">جستجو</button>

        <Passengers id="passengers" className={isHidden ? 'hidden' : null}>
          <div className="chooseNum">
            <section>
              <p>
                بزرگسال <span>( 12 سال به بالا)</span>
              </p>
              <section>
                <span className="NumButton" onClick={addAdult}>
                  <BsPlusLg />
                </span>
                <span className="ShowNum">{adult}</span>
                <span className="NumButton" onClick={minuseAdult}>
                  <AiOutlineMinus />
                </span>
              </section>
            </section>
            <section>
              <p>
                کودک <span>( 2 تا 12 سال)</span>
              </p>
              <section>
                <span className="NumButton" onClick={addChild}>
                  <BsPlusLg />
                </span>
                <span className="ShowNum">{child}</span>
                <span className="NumButton" onClick={minuseChild}>
                  <AiOutlineMinus />
                </span>
              </section>
            </section>
            <section>
              <p>
                نوزاد <span>( 10 روز تا 2 سال)</span>
              </p>
              <section>
                <span className="NumButton" onClick={addNewBorn}>
                  <BsPlusLg />
                </span>
                <span className="ShowNum">{newBorn}</span>
                <span className="NumButton" onClick={minuseNewBorn}>
                  <AiOutlineMinus />
                </span>
              </section>
            </section>
          </div>
        </Passengers>
      </Inputs>

      <Support />

      <Faq FaqElems={FaqElems} />
    </>
  );
};

export default OutsideIran;

// const Inputs = styled.div`
//   background-color: #ffff;
//   width: 1120px;
//   margin: 0 auto;
//   direction: rtl;
//   position: relative;
//   margin-top: 0px;
//   padding: 60px 36px 50px 36px;
//   border: 1px solid rgba(0, 0, 0, 0.1);
//   border-top: none;
//   border-radius: 0 0 15px 15px;

//   @media (max-width: 900px) {
//     display: none;
//   }
//   @media (min-width: 900px) and (max-width: 1120px) {
//       width: 90%;
//     }

//   .textInput {
//     direction: rtl;
//     width: 220px;
//     height: 48px;
//     border: 1px solid rgba(0, 0, 0, 0.5);
//     border-radius: 5px;
//     padding-right: 16px;
//     font-size: 18px;

//     @media (min-width: 900px) and (max-width: 1120px) {
//       width: 150px;
//     }
//     :focus {
//       outline: none;
//       border: 2px solid rgba(0, 0, 0, 0.5);
//     }

//     ::placeholder {
//       font-size: 16px;
//       font-weight: 500;
//     }
//   }

//   .changeCities {
//     width: 35px;
//     height: 35px;
//     border-radius: 50%;
//     font-size: 20px;
//     vertical-align: middle;
//     padding-top: 5px;
//     border: 1px solid rgba(0, 0, 0, 0.5);
//     color: rgba(0, 0, 0, 0.5);
//     cursor: pointer;
//     position: absolute;
//     right: 237px;
//     top: 114px;

//     @media (min-width: 900px) and (max-width: 1120px) {
//       right: 168px;
//     }
//   }

//   .searchButton {
//     display: inline-block;
//     position: relative;
//     top: -1px;
//     width: 180px;
//     height: 48px;
//     background-color: #e73511;
//     text-align: center;
//     color: #ffff;
//     font-size: 14px;
//     font-weight: 400;
//     border: 1px solid rgba(0, 0, 0, 0.5);
//     border-radius: 5px;
//     margin-right: 10px;
//     cursor: pointer;

//     @media (min-width: 900px) and (max-width: 1120px) {
//       width: 110px;
//     }
//   }
// `;
// const DatePickers = styled(DatePicker)`
//   display: inline-block;
//   width: 270px;
//   position: relative;
//   vertical-align: middle;
//   top: -2px;
//   right: 10px;

//   @media (min-width: 900px) and (max-width: 1000px) {
//     width: 160px;
//   }
//   label {
//     position: absolute;
//     z-index: 2;
//     top: -10px;
//     right: 15px;
//     padding: 0 3px;
//     background-color: #ffff;
//   }
//   .hTgfFn {
//     height: 48px !important;
//     border-radius: 5px !important;
//     border-color: rgba(0, 0, 0, 0.5);
//     font-size: 18px;
//     outline: none;
//   }
// `;
// const Select = styled.select`
//   display: inline-block;
//   width: 150px;
//   border: 1px solid rgba(0, 0, 0, 0.5);
//   border-radius: 20px;
//   padding: 5px 10px;
//   outline: none;
//   margin: 0 5px 10px 5px;
//   font-size: 16px;
//   font-weight: 400;
//   color: rgba(0, 0, 0, 0.7);
// `;

// const Passengers = styled.div`
//   width: 350px;
//   background-color: #ffff;
//   position: absolute;
//   padding: 10px 15px;
//   border: 1px solid rgba(0, 0, 0, 0.1);
//   border-radius: 10px;
//   left: 120px;
//   z-index: 4;
//   .chooseNum {
//     & > section {
//       display: flex;
//       justify-content: space-between;
//       margin: 15px 0;

//       p {
//         font-size: 16px;
//         font-weight: 400;
//         color: rgba(0, 0, 0, 0.9);

//         span {
//           color: rgba(0, 0, 0, 0.6);
//         }
//       }
//       section {
//         .NumButton {
//           display: inline-block;
//           width: 24px;
//           height: 24px;
//           background-color: #0077db;
//           font-size: 12px;
//           border-radius: 6px;
//           color: #ffff;
//           text-align: center;
//           cursor: pointer;

//           svg {
//             vertical-align: middle;
//           }
//         }
//         .ShowNum {
//           margin: 0 20px;
//           font-size: 17px;
//           font-weight: 400;
//           color: rgba(0, 0, 0, 0.9);
//         }
//       }
//     }
//   }
// `;
